var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeployedCodeHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10945_18755",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D5A407"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10945_18755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 2L3.0375 3.7125L6 5.425L8.9625 3.7125L6 2ZM1.5 7.9875V4.0125C1.5 3.82917 1.54375 3.6625 1.63125 3.5125C1.71875 3.3625 1.84167 3.24167 2 3.15L5.5 1.1375C5.58333 1.09583 5.66458 1.0625 5.74375 1.0375C5.82292 1.0125 5.90833 1 6 1C6.09167 1 6.17917 1.0125 6.2625 1.0375C6.34583 1.0625 6.425 1.09583 6.5 1.1375L10 3.15C10.1583 3.24167 10.2813 3.3625 10.3688 3.5125C10.4563 3.6625 10.5 3.82917 10.5 4.0125V5.5C10.5 5.64167 10.4521 5.76042 10.3562 5.85625C10.2604 5.95208 10.1417 6 10 6C9.85833 6 9.73958 5.95208 9.64375 5.85625C9.54792 5.76042 9.5 5.64167 9.5 5.5V4.55L6.4875 6.2875C6.32917 6.37917 6.1625 6.425 5.9875 6.425C5.8125 6.425 5.64583 6.37917 5.4875 6.2875L2.5 4.55V7.975L5.25 9.575C5.325 9.61667 5.38542 9.675 5.43125 9.75C5.47708 9.825 5.5 9.90833 5.5 10C5.5 10.1917 5.41667 10.3354 5.25 10.4313C5.08333 10.5271 4.91667 10.5292 4.75 10.4375L2 8.85C1.84167 8.75833 1.71875 8.6375 1.63125 8.4875C1.54375 8.3375 1.5 8.17083 1.5 7.9875ZM9 12C8.30833 12 7.71875 11.7563 7.23125 11.2688C6.74375 10.7812 6.5 10.1917 6.5 9.5C6.5 8.80833 6.74375 8.21875 7.23125 7.73125C7.71875 7.24375 8.30833 7 9 7C9.69167 7 10.2812 7.24375 10.7688 7.73125C11.2563 8.21875 11.5 8.80833 11.5 9.5C11.5 10.1917 11.2563 10.7812 10.7688 11.2688C10.2812 11.7563 9.69167 12 9 12ZM9.25 9.4V8.25C9.25 8.18333 9.225 8.125 9.175 8.075C9.125 8.025 9.06667 8 9 8C8.93333 8 8.875 8.025 8.825 8.075C8.775 8.125 8.75 8.18333 8.75 8.25V9.3875C8.75 9.45417 8.7625 9.51875 8.7875 9.58125C8.8125 9.64375 8.85 9.7 8.9 9.75L9.65 10.5C9.7 10.55 9.75833 10.575 9.825 10.575C9.89167 10.575 9.95 10.55 10 10.5C10.05 10.45 10.075 10.3917 10.075 10.325C10.075 10.2583 10.05 10.2 10 10.15L9.25 9.4Z",
    fill: "#D5A407"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployedCodeHistory);
export default __webpack_public_path__ + "static/media/deployed_code_history.c361d8d6d19621dcede385877f9a0b18.svg";
export { ForwardRef as ReactComponent };